import React, {Component, useEffect, useState} from 'react';
import axios from "axios";
import {Routes, Route, useParams, Navigate} from 'react-router-dom';
import "yet-another-react-lightbox/styles.css";
import Layout from "./Components/Layout";
import DynamicFormComponent from './Components/DynamicFormComponent';

const AddRecord = () => {
    
    const [redirect, setRedirect] = React.useState(false);
    const [supplierDropdown, setSupplierDropdown] = useState([]);
    const [selectedOption, setSelectedOption] = useState(0);
    const [selectedSupplierName, setSelectedSupplierName] = useState('');
    const [supplierData, setSupplierData] = useState({});

    let { recordId } = useParams();
    let { supplierDataId } = useParams();
    supplierDataId = supplierDataId || 0;
    recordId = recordId || 0;


    useEffect(() => {
        setSelectedOption(recordId);
        axios.get(`get-suppliers-dropdown/${supplierDataId}`)
            .then(response => {
                const suppliers = response.data.suppliers; // Fixed: Added .data
                const supplier = response.data.supplierData; // Fixed: Added .data
                const PeakItem = response.data.peakItem;
                setSupplierDropdown(suppliers);
                if(recordId > 0)
                {
                    const selectedSupplier = suppliers.find(supplier => supplier.id == recordId);
                    if (selectedSupplier) {
                        setSelectedSupplierName(selectedSupplier.company);
                    }
                    setSupplierData({
                        PeakItem: PeakItem,
                        SupplierName: (selectedSupplier.company != "") ? selectedSupplier.company: "",
                        SupplierId: recordId,
                        SupplierItem: supplier.SupplierItem,
                        ItemDescription:supplier.ItemDescription,
                        ItemCategory: supplier.ItemCategory,
                        MOQ:supplier.MOQ,
                        PackSize: supplier.PackSize,
                        UM:supplier.UM,
                        TierQty1:supplier.TierQty1,
                        TierQty1Cost:supplier.TierQty1Cost,
                        TierQty2:supplier.TierQty2,
                        TierQty2Cost: supplier.TierQty2Cost,
                        TierQty3:supplier.TierQty3,
                        TierQty3Cost:supplier.TierQty3Cost,
                        LeadTime: supplier.LeadTime,
                        GoodThruDate:supplier.GoodThruDate,
                        Manufacturer:supplier.Manufacturer,
                        FOBOrigin:supplier.FOBOrigin,
                        CountryOfExtraction:supplier.CountryOfExtraction,
                        CountryOfOrigin:supplier.CountryOfOrigin,
                        HTSUSCode:supplier.HTSUSCode,
                        ID:supplier.SupplierDataMasterId,
                        ShipmentPackaging:supplier.ShipmentPackaging,
                        ShipmentPackagingOther:supplier.ShipmentPackagingOther
                    })
                }

            }).catch(error => {
            console.error('There was an error!', error);
        });
    }, []);

    const fields = [
        { name: 'SupplierName', label: 'Supplier Name',required: true, hidden:true },
        { name: 'SupplierId', label: 'Supplier Id', type: 'text',required: true, hidden:true },
        { name: 'PeakItem', label: 'Apex#', type: 'text',required: true },
        { name: 'SupplierItem', label: 'Supplier Item #', type: 'text',required: true, note: '(Use Supplier # or APEX # not N/A)' },
        { name: 'ItemDescription', label: 'Item Description', type: 'text',required: true },
        { name: 'ItemCategory', label: 'Item Category', type: 'text',required: true },
        { name: 'MOQ', label: 'MOQ', type: 'text',required: true },
        { name: 'PackSize', label: 'Pack Size', type: 'text',required: true },
        { name: 'UM', label: 'U/M', type: 'text',required: true },
        { name: 'TierQty1', label: 'Tier Qty 1', type: 'text',required: true },
        { name: 'TierQty1Cost', label: 'Cost', type: 'number',required: true,  min: 0, step: 0.01, icon: 'fa-solid fa-dollar-sign' },
        { name: 'TierQty2', label: 'Tier Qty 2', type: 'text' },
        { name: 'TierQty2Cost', label: 'Cost', type: 'number', icon: 'fa-solid fa-dollar-sign',  min: 0, step: 0.01 },
        { name: 'TierQty3', label: 'Tier Qty 3', type: 'text' },
        { name: 'TierQty3Cost', label: 'Cost', type: 'number', icon: 'fa-solid fa-dollar-sign',  min: 0, step: 0.01 },
        { name: 'LeadTime', label: 'Lead Time',type: 'number',required: true },
        { name: 'GoodThruDate', label: 'Good Thru Date', type: 'date',required: true },
        // Shipment Packaging select field
        { 
            name: 'ShipmentPackaging', 
            label: 'Shipment Packaging', 
            type: 'select', 
            required: false,
            options: [
                'Drum', 
                'Box', 
                'Bag', 
                'Pail', 
                'Other (Specify)'
            ],
            placeholder: 'Select packaging type',
            icon: 'fa-solid fa-box'
        },
        
        // Conditional field - only required when "Other (Specify)" is selected
        {
            name: 'ShipmentPackagingOther',
            label: 'Please Specify Packaging Type',
            type: 'text',
            required: true, // This will only be enforced when the field is visible
            placeholder: 'Enter packaging type',
            showWhen: {
                field: 'ShipmentPackaging',
                value: 'Other (Specify)'
            }
        },
        { name: 'Manufacturer', label: 'Manufacturer', type: 'text'},
        { name: 'FOBOrigin', label: 'FOB Origin', type: 'text'},
        { name: 'CountryOfExtraction', label: 'Country of Extraction', type: 'text' },
        { name: 'CountryOfOrigin', label: 'Country of Origin', type: 'text',required: false },
        { name: 'HTSUSCode', label: 'HTSUS Code', type: 'text',required: false },
        { name: 'ID', label: 'ID', type: 'text',required: false, hidden: true },
        // Add file upload field to the fields array
        { name: 'confirmationEmail', label: 'Confirmation Email', type: 'file', required: true,
            accept: '.pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif',
            helpText: 'Required - PDF, DOC, DOCX, TXT, JPG, PNG, GIF - Max 5MB' }
    ];
    
    const values = {
        SupplierName: selectedSupplierName,
        SupplierId: selectedOption,
        PeakItem: ""
    }

    const getFormattedDate = (dateString) => {
        if(dateString !== undefined)
        {
            const myDate = new Date(dateString);

            return  myDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });

        }

    };

    const handleSelectChange = (event) => {
        const newSelectedOption = event.target.value;
        const selectedSupplier = supplierDropdown.find(supplier => supplier.id == newSelectedOption);

        let newSupplierName = '';
        if (selectedSupplier) {
            newSupplierName = selectedSupplier.company;
            setSelectedSupplierName(newSupplierName);
        }

        setSelectedOption(newSelectedOption);

        // Set supplierData with the new values
        setSupplierData({
            SupplierName: newSupplierName,
            SupplierId: newSelectedOption
        });
    };

    // Handle form submission success callback
    const handleFormSuccess = (response) => {
        console.log('Form submitted successfully:', response);
        // You can add additional logic here if needed
    };

    // Handle form submission error callback
    const handleFormError = (error) => {
        console.error('Form submission error:', error);
        // You can add additional error handling here if needed
    };

    // Custom validation before form submission
    const handleFormSubmit = (formData) => {
        // Check if supplier is selected
        if (selectedOption === 0 || selectedOption === '0') {
            alert('Please select a supplier before submitting the form');
            return false;
        }
        return true;
    };

    if(redirect)
    {
        return (<Navigate to="/home"/>)
    }
    else {
        return (
            <Layout>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px 0px' }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="card" style={{ border: '1px solid #e5e7eb' }}>
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <label htmlFor="SupplierName" className="form-label">
                                                Supplier Name <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                style={{ height: '45px' }}
                                                value={selectedOption}
                                                onChange={handleSelectChange}
                                                required
                                            >
                                                <option value={0}>Select a supplier...</option>
                                                {supplierDropdown.map((option, index) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.company}
                                                    </option>
                                                ))}
                                            </select>
                                            {selectedOption === 0 && (
                                                <div className="text-danger mt-2" style={{fontSize: '14px'}}>
                                                    <i className="ti-alert-circle me-1"></i>
                                                    Please select a supplier
                                                </div>
                                            )}
                                        </div>

                                        <DynamicFormComponent
                                            fields={fields}
                                            externalValues={supplierData}
                                            onSuccess={handleFormSuccess}
                                            onError={handleFormError}
                                            onBeforeSubmit={handleFormSubmit}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

}

export default AddRecord;